import { Box, Col, Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import type { ILpElementLink, ILpElementSimpleList } from 'declarations/contentful';

import { isSimpleLink } from '../../../../cms/utils';

const FooterNav = ({ footerNav }: { footerNav?: ILpElementSimpleList[] }) => {
  return (
    <Col className="min-w-0 flex-1">
      <Row className="flex-wrap justify-between gap-6 md:flex-nowrap">
        {footerNav &&
          footerNav.map((navItem, i) => {
            return (
              <Col key={i} className="min-w-0 grow basis-[45%] gap-6">
                <Text as="h3" className="text-subheader-sm">
                  {navItem.fields.title}
                </Text>
                <Col role="list" className="gap-4">
                  {(
                    navItem.fields.links?.filter(
                      (link): link is ILpElementLink => link != null && isSimpleLink(link),
                    ) ?? []
                  ).map((link, linkIndex) => (
                    <Box role="listitem" key={linkIndex}>
                      <Box
                        analyticsName={`footer-link-column-${link.fields.text || ''}`}
                        href={link.fields.url || ''}
                        aria-label={link.fields.text || ''}
                        className="w-max max-w-full text-body-md"
                      >
                        {link.fields.text || ''}
                      </Box>
                    </Box>
                  ))}
                </Col>
              </Col>
            );
          })}
      </Row>
    </Col>
  );
};

export default FooterNav;
